import isBoolean from 'hs-lodash/isBoolean';
// TODO: move to composer-data
import invariant from 'conversations-thread-data/utils/invariant';
export const messengerDisconnected = ({
  isMessengerDisconnected
}) => {
  invariant(isBoolean(isMessengerDisconnected), 'isMessengerDisconnected is required for messengerDisconnected disabling strategy');
  return isMessengerDisconnected ? {
    disabled: true,
    sendDisabledReason: 'MESSENGER_DISCONNECTED'
  } : null;
};